import React, { useState, useRef } from 'react';
import { AgGridReact } from "@ag-grid-community/react";
import DatePicker from "react-multi-date-picker";
import { useEmployeeAttendanceInfo } from "../../Hooks/Features/HrLens/useEmployeeAttendanceInfo";
import { SkeletonDataTable } from "../Loader/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCommon } from "../../Hooks/Common/useCommon";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import PunchReport from "./PunchReport";
import CommonFilterDropdown from "../CommonCompo/CommonFilterDropdown/CommonFilterDropdown";
ModuleRegistry.registerModules([ClientSideRowModelModule, RowGroupingModule]);

const EmployeeAttendanceInfo = () => {

    const { options, filterValues, setFilterValues, hoveredRange, setHoveredRange, columnDefs, rowData, getAttendanceData, loader, isChange, setIsChange, legendItems, handleSetUserOptions, tagRef, selectedTab, callPunchApi, setCallPunchApi } = useEmployeeAttendanceInfo();
    const { checkPermission } = useCommon();
    const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
    const datePickerRef = useRef(null);

    return (
        <div ref={() => checkPermission("Attendance", tagRef)}>
            <div ref={tagRef} id='{"tabname": "attendance", "data": "employee_attendance_tab"}'>

                <div className="d-flex align-items-center justify-content-between gap-3 w-100 mt-2">
                    <div className="d-flex align-items-center gap-2 flex-grow-1">
                        {selectedTab === "attendance" && (
                            <div className='d-flex justify-content-start gap-3 p-1 flex-wrap'>
                                {legendItems.map((item, idx) => (
                                    <div className='d-flex gap-1 align-items-center' key={idx}>
                                        <div
                                            style={{
                                                width: "12px",
                                                height: "12px",
                                                borderRadius: "50%",
                                                backgroundColor: item?.color,
                                            }}
                                            title={item?.title}
                                        ></div>
                                        <span className="small text-muted">{item?.title}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="d-flex justify-content-end gap-2">
                        <button className="sk-btn sk-btn-primary rounded" onClick={() => selectedTab === "attendance" ? getAttendanceData(false, false, null, false, "refresh") : setCallPunchApi(true)} title="Refresh">
                            <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                        </button>
                        <button className="sk-btn sk-btn-primary rounded" onClick={() => setShowFiltersDrawer(true)} title="Filters">
                            <FontAwesomeIcon icon="fa-solid fa-filter" />
                        </button>
                    </div>
                </div>
            </div>
            {selectedTab === "attendance" ?
                <div className="ag-theme-alpine mt-2" style={{ height: "calc(100vh - 110px)" }}>
                    {loader ? <div style={{ height: "100%" }}><SkeletonDataTable numSkeletons={21} /></div> :
                        <AgGridReact columnDefs={columnDefs} rowData={rowData} headerHeight={60} rowHeight={30} autoGroupColumnDef={{ pinned: "left", hide: true, width: 150 }} groupDefaultExpanded="-1" />
                    }
                </div> :
                <div>
                    <PunchReport filterValues={filterValues} hoveredRange={hoveredRange} callPunchApi={callPunchApi} setCallPunchApi={setCallPunchApi} />
                </div>
            }

            {/* Right Panel Filters Drawer */}
            <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
                <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
                    <div className="sk-drawer-header">
                        <h5 className="sk-drawer-title">Filters</h5>
                        <div className="d-flex align-items-center gap-2">
                            <button className="sk-drawer-clear-btn" onClick={() => {
                                setFilterValues((prev) => ({
                                    ...prev,
                                    projects: [],
                                    project_leads: [],
                                    users: [],
                                    attendance_type: [],
                                    type: "",
                                    time: "",
                                    apiCall: true
                                }));
                            }}>Clear All</button>
                            <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                                <FontAwesomeIcon icon="fa-solid fa-xmark" />
                            </button>
                        </div>
                    </div>
                    <div className="sk-drawer-body">
                        <div className='d-flex flex-column gap-4'>
                            {/* Date Picker Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Date Range</div>
                                <DatePicker ref={datePickerRef}
                                    value={hoveredRange}
                                    onChange={(date) => {
                                            if (!date || date.length === 2) {
                                                setHoveredRange(date);
                                        if (date && date.length === 2) {
                                            setFilterValues((prev) => ({ ...prev, apiCall: true }));
                                            datePickerRef.current?.closeCalendar();
                                        }
                                            }
                                        }}
                                    range
                                    rangeHover
                                    style={{ width: "100%" }}
                                    containerStyle={{ width: "100%" }}
                                    inputClass="w-100 sk-input-dd"
                                />
                            </div>

                            {/* Attendance / DevOps Dropdown Filters */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Dimensions</div>
                                <CommonFilterDropdown
                                    fields={[
                                        { key: "projects", label: "Projects", col: 12, isHide: !options?.users?.length },
                                        { key: "project_leads", label: "Leads", col: 12, isHide: !options?.users?.length },
                                        { key: "users", label: "Users", col: 12, isHide: !options?.users?.length },
                                        { key: "attendance_type", label: "Attendance Types", col: 12, isHide: selectedTab !== "attendance" }
                                    ]}
                                    filterValues={filterValues}
                                    setFilterValues={setFilterValues}
                                />
                            </div>

                            {/* Radio Filters (only for punch report tab) */}
                            {selectedTab === "punch" && (
                                <div className="sk-drawer-filter-group">
                                    <div className="task-list-filter-label">Punch Report Type</div>
                                    <div className='sk-segment-control mb-3'>
                                        <button 
                                            type="button" 
                                            className={`sk-segment-btn ${!filterValues.type ? 'active' : ''}`}
                                            onClick={() => setFilterValues((prev) => ({ ...prev, type: "", apiCall: true }))}
                                        >
                                            All Logs
                                        </button>
                                        <button 
                                            type="button" 
                                            className={`sk-segment-btn ${filterValues.type === 'I' ? 'active' : ''}`}
                                            onClick={() => setFilterValues((prev) => ({ ...prev, type: "I", apiCall: true }))}
                                        >
                                            Late Coming
                                        </button>
                                        <button 
                                            type="button" 
                                            className={`sk-segment-btn ${filterValues.type === 'O' ? 'active' : ''}`}
                                            onClick={() => setFilterValues((prev) => ({ ...prev, type: "O", apiCall: true }))}
                                        >
                                            Early Leave
                                        </button>
                                    </div>

                                    {(filterValues?.type === "O" || filterValues?.type === "I") && (
                                        <div className='mt-2'>
                                            <div className="task-list-filter-label">Threshold (Minutes)</div>
                                            <input
                                                type="number"
                                                value={filterValues.time || ""}
                                                className="sk-input-dd w-100"
                                                placeholder="Enter minutes"
                                                onChange={(e) => {
                                                    setFilterValues((prev) => ({ ...prev, time: e.target.value }));
                                                    setIsChange(true);
                                                }}
                                                onBlur={() => {
                                                    if (isChange) {
                                                        setCallPunchApi(true);
                                                        setIsChange(false);
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="sk-drawer-footer">
                        <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
                            if (selectedTab === "attendance") {
                                getAttendanceData(false, false, null, false, "refresh");
                            } else {
                                setCallPunchApi(true);
                            }
                            setShowFiltersDrawer(false);
                        }}>Apply Filters</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmployeeAttendanceInfo;
